import { GET_ROLE, GET_ALL_ROLES, RESET_ROLE, GET_ALL_PARENT_ROLES, DELETE_ROLE, GET_ROLES_FOR_SELECT } from './types'

const initialState = { role: {}, roles: [], rolesForSelect: [] }

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ROLES_FOR_SELECT: {
      return { ...state, rolesForSelect: action.payload }
    }
    case GET_ROLE: {
      return { ...state, role: action.payload }
    }
    case GET_ALL_ROLES: {
      return { ...state, roles: action.payload }
    }
    case GET_ALL_PARENT_ROLES: {
      return { ...state, parentRoles: action.payload }
    }
    case RESET_ROLE: {
      return { ...state, role: initialState.role }
    }
    case DELETE_ROLE: {
      return {
        ...state,
        roles: {
          ...state.roles,
          query: {
            ...state.roles.query,
            totalRecords: state.roles.query.totalRecords - 1,
          },
          data: state.roles.data.filter((table) => table.id !== action.payload),
        },
        isUpdated: true,
      }
    }
    default:
      return state
  }
}
